import { apiCall } from './gqlClient';
const GETPUBLICSESSIONS_QUERY = "\n  query getPublicSessions($classId: Int!) {\n    getPublicSessions(classId: $classId)\n    {\n      id\n\t\t\tclassId\n\t\t\tdate\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tprice\n\t\t\tcreated\n\t\t\tstatus\n\t\t\tcurrentCapacity\n\t\t\tavailableCapacity\n\t\t\tlocationType\n\t\t\tisSessionBought\n\t\t\tcanBeBought\n\t\t\tcanBeReimbursed\n\t\t\tmodel\n\t\t\tduration\n\t\t\tsubscriptionId\n\t\t\tclientEmail\n\t\t\tnewStartTime\n\t\t\tnewEndTime\n\t\t\tresourceEmail\n\t\t\tnewStartDate\n\t\t\tnewEndDate\n      ...fragments\n    }\n  }";
export const getPublicSessionsApiCall = async function (_ref) {
  let {
    classId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETPUBLICSESSIONS_QUERY,
    variables: {
      classId
    },
    fragments
  });
};
const GETSESSIONSBYCLASSID_QUERY = "\n  query getSessionsByClassId($classId: Int!) {\n    getSessionsByClassId(classId: $classId)\n    {\n      id\n\t\t\tclassId\n\t\t\tdate\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tprice\n\t\t\tcreated\n\t\t\tstatus\n\t\t\tcurrentCapacity\n\t\t\tavailableCapacity\n\t\t\tlocationType\n\t\t\tisSessionBought\n\t\t\tcanBeBought\n\t\t\tcanBeReimbursed\n\t\t\tmodel\n\t\t\tduration\n\t\t\tsubscriptionId\n\t\t\tclientEmail\n\t\t\tnewStartTime\n\t\t\tnewEndTime\n\t\t\tresourceEmail\n\t\t\tnewStartDate\n\t\t\tnewEndDate\n      ...fragments\n    }\n  }";
export const getSessionsByClassIdApiCall = async function (_ref2) {
  let {
    classId
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETSESSIONSBYCLASSID_QUERY,
    variables: {
      classId
    },
    fragments
  });
};
const SAVESESSION_QUERY = "\n  mutation saveSession($request: SessionCreateInput!, $isDeal: Boolean) {\n    saveSession(request: $request, isDeal: $isDeal)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const saveSessionApiCall = async function (_ref3) {
  let {
    request,
    isDeal
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVESESSION_QUERY,
    variables: {
      request,
      isDeal
    },
    fragments
  });
};
const UPDATESESSIONFROMEVENT_QUERY = "\n  mutation updateSessionFromEvent($id: Int!, $startDate: DateTime!, $startTime: DateTime!, $endTime: DateTime!, $subscriptionsEmails: [String], $resourceId: Int) {\n    updateSessionFromEvent(id: $id, startDate: $startDate, startTime: $startTime, endTime: $endTime, subscriptionsEmails: $subscriptionsEmails, resourceId: $resourceId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const updateSessionFromEventApiCall = async function (_ref4) {
  let {
    id,
    startDate,
    startTime,
    endTime,
    subscriptionsEmails,
    resourceId
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATESESSIONFROMEVENT_QUERY,
    variables: {
      id,
      startDate,
      startTime,
      endTime,
      subscriptionsEmails,
      resourceId
    },
    fragments
  });
};
const DELETESESSION_QUERY = "\n  mutation deleteSession($id: Int!) {\n    deleteSession(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const deleteSessionApiCall = async function (_ref5) {
  let {
    id
  } = _ref5;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DELETESESSION_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const CANCELSESSION_QUERY = "\n  mutation cancelSession($id: Int!) {\n    cancelSession(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const cancelSessionApiCall = async function (_ref6) {
  let {
    id
  } = _ref6;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CANCELSESSION_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const CANCELTOTALSESSION_QUERY = "\n  mutation cancelTotalSession($sessionId: Int!, $classId: Int!) {\n    cancelTotalSession(sessionId: $sessionId, classId: $classId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const cancelTotalSessionApiCall = async function (_ref7) {
  let {
    sessionId,
    classId
  } = _ref7;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CANCELTOTALSESSION_QUERY,
    variables: {
      sessionId,
      classId
    },
    fragments
  });
};
const CHANGEUSERSESSIONSNUMBER_QUERY = "\n  mutation changeUserSessionsNumber($id: Int!, $numberOfSessions: Int!, $startTime: DateTime!, $endTime: DateTime!, $action: Boolean!) {\n    changeUserSessionsNumber(id: $id, numberOfSessions: $numberOfSessions, startTime: $startTime, endTime: $endTime, action: $action)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const changeUserSessionsNumberApiCall = async function (_ref8) {
  let {
    id,
    numberOfSessions,
    startTime,
    endTime,
    action
  } = _ref8;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CHANGEUSERSESSIONSNUMBER_QUERY,
    variables: {
      id,
      numberOfSessions,
      startTime,
      endTime,
      action
    },
    fragments
  });
};